(function () {
    'use strict';

    angular
        .module('app.campaignInfluencersManagePage')
        .controller('campaignInfluencersManagePageCtrl', ['$scope', '$rootScope', '$http', '$modal', '$stateParams', 'adminService', 'campaignInfluencersManagePageService', '$state', 'localStorageService', '$location', 'TRACK_EVENTS',
            function ($scope, $rootScope, $http, $modal, $stateParams, adminService, campaignInfluencersManagePageService, $state, localStorageService, $location, TRACK_EVENTS) {
                $scope.currentPage = 1;
                $scope.pageSize = 25;
                $scope.campaignInfluencers = [];
                $scope.currentData = null;
                $scope.isGettingTotalCount = true;

                $scope.getCampaignsForInfluencer = function () {
                    campaignInfluencersManagePageService.getCampaignList($scope.currentPage, $scope.pageSize, true)
                        .then(function (result) {
                            $scope.campaignInfluencers = result.data;
                        });

                    $scope.getNumberOfCampaignsForInfluencer();
                }

                $scope.getNumberOfCampaignsForInfluencer = function () {
                    $scope.isGettingTotalCount = true;
                    campaignInfluencersManagePageService.getNumberOfCampaignsForInfluencer()
                        .then(function (result) {
                            $scope.isGettingTotalCount = false;
                            $scope.totalRow = result.totalRow;
                            $scope.pagination();
                        });
                }

                $scope.pagination = function () {
                    $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
                }

                $scope.updatePage = function (val) {
                    $scope.currentPage = val;
                    $scope.getCampaignsForInfluencer();
                }

                $scope.acceptCampaign = function (campaignInfluencerRow) {
                    var params = {
                        campaignInfluencerId: campaignInfluencerRow.campaign_influencer_id,
                        accessLevel: $rootScope.currentUser.role.accessLevel,
                    }

                    campaignInfluencersManagePageService.acceptCampaign(params, true).then(function (result) {
                        campaignInfluencerRow.status = "accepted";
                    });
                }

                $scope.rejectCampaign = function (campaignInfluencerRow, index) {
                    var params = {
                        campaignInfluencerId: campaignInfluencerRow.campaign_influencer_id,
                        accessLevel: $rootScope.currentUser.role.accessLevel,
                    }

                    campaignInfluencersManagePageService.rejectCampaign(params, true).then(function (result) {
                        $scope.campaignInfluencers.splice(index, 1);
                        $scope.totalRow--;
                    });
                }

                $scope.viewCampaignInfo = function (campaignInfluencerRow, index) {
                    var afterReviewCampaignAccepted = function () {
                        $scope.campaignInfluencers[index].status = "accepted";
                    }

                    var afterReviewCampaignRejected = function () {
                        $scope.campaignInfluencers.splice(index, 1);
                        $scope.totalRow--;
                    }

                    var viewCampaignInfoModalScope = $rootScope.$new();
                    viewCampaignInfoModalScope.paramsFromParent = {
                        afterReviewCampaignAccepted: afterReviewCampaignAccepted,
                        afterReviewCampaignRejected: afterReviewCampaignRejected,
                        campaignInfluencerId: campaignInfluencerRow.campaign_influencer_id,
                        campaignId: campaignInfluencerRow.campaign_id,
                        influencerId: campaignInfluencerRow.influencer_id
                    };

                    var viewCampaignInfoModalInstance = $modal.open({
                        scope: viewCampaignInfoModalScope,
                        templateUrl: 'app/campaign/campaignInfluencersManagePage/viewCampaignInfo/viewCampaignInfo.html?app_v=deployDate',
                        controller: 'viewCampaignInfoCtrl',
                    });

                    $scope.viewCampaignInfoModalInstance = viewCampaignInfoModalInstance;
                }

                $scope.saveImg = function (files) {
                    var fd = new FormData();
                    //Take the first selected file
                    fd.append("file", files[0]);

                    campaignInfluencersManagePageService.saveImg(fd).then(function (result) {

                    });
                }

                $scope.gotoInfluencerCampaignActivity = function (row) {
                    // Mixpanel tracking campaign clicking
                    analytics.track(
                        TRACK_EVENTS.CLICK_ON_CAMPAIGN.EVT_NAME,
                        {
                            "item": TRACK_EVENTS.CLICK_ON_CAMPAIGN.ITEM_NAME,
                            "target_type": TRACK_EVENTS.CLICK_ON_CAMPAIGN.ITEM_NAME,
                            "target_name": row.campaign_name,
                            "target_id": row.campaign_id
                        }
                    );
                    $rootScope.previousPageOfActivityPage = $location.absUrl();
                    $state.transitionTo('home.campaignActivityPage', { campaign_influencer_id: row.campaign_influencer_id }, {
                        reload: false,
                        inherit: false,
                        notify: true
                    });
                }

                $scope.getCampaignsForInfluencer();
            }
        ]);
})();
